module.exports = __webpack_public_path__ + "static/media/image.39aa711c.svg";